<template>
  <PageWrapper>
    <template v-slot:content>
      <el-row :gutter="20">
        <el-col  :span="getIsMobile?24:12">
          <h2 style="text-align: center">需方</h2>
          <el-form ref="needFormRef"  :label-position="getIsMobile?'top':'right'" :model="needForm" class="company-info_form" label-width="120px">
            <el-form-item label="单位名称" prop="dscompany">
              <el-input placeholder="请输入单位名称" v-model="needForm.dscompany" @click.native="dialog = true"/>
            </el-form-item>
            <el-form-item label="委托代理人" prop="dslxr">
              <el-input placeholder="请输入委托代理人" v-model="needForm.dslxr" />
            </el-form-item>
            <el-form-item label="联系电话" prop="dstel">
              <el-input placeholder="请输入联系电话" v-model="needForm.dstel" />
            </el-form-item>
            <el-form-item label="传真" prop="dsmax">
              <el-input placeholder="请输入传真" v-model="needForm.dsmax" />
            </el-form-item>
            <el-form-item label="开户银行" prop="dsbank">
              <el-input placeholder="请输入开户银行" v-model="needForm.dsbank" />
            </el-form-item>
            <el-form-item label="账号" prop="dsbanknum">
              <el-input placeholder="请输入账号" v-model="needForm.dsbanknum" />
            </el-form-item>
            <el-form-item label="税号" prop="dsshuihao">
              <el-input placeholder="请输入税号" v-model="needForm.dsshuihao" />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col  :span="getIsMobile?24:12">
          <h2 style="text-align: center">供方</h2>
          <el-form ref="offeringFormRef"  :label-position="getIsMobile?'top':'right'" :model="offeringsForm" class="company-info_form" label-width="120px">
            <el-form-item label="单位名称" prop="">
              <el-input placeholder="请输入单位名称" v-model="offeringsForm.cname" />
            </el-form-item>
            <el-form-item label="委托代理人" prop="">
              <el-input placeholder="请输入委托代理人" v-model="offeringsForm.rname" />
            </el-form-item>
            <el-form-item label="联系电话" prop="">
              <el-input placeholder="请输入联系电话" v-model="offeringsForm.tel" />
            </el-form-item>
            <el-form-item label="传真" prop="">
              <el-input placeholder="请输入传真" v-model="offeringsForm.max" />
            </el-form-item>
            <el-form-item label="开户银行" prop="">
              <el-input placeholder="请输入开户银行" v-model="offeringsForm.bank" />
            </el-form-item>
            <el-form-item label="账号" prop="">
              <el-input placeholder="请输入账号" v-model="offeringsForm.banknum" />
            </el-form-item>
            <el-form-item label="税号" prop="">
              <el-input placeholder="请输入税号" v-model="offeringsForm.shuihao" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleReset">重 置</el-button>
          <el-button type="primary" @click="handleSubmit">生成合同</el-button>
        </div>
      <el-dialog
        v-if="dialog"
        :visible.sync="dialog"
        title="选择报价公司"
        :width="getIsMobile?'100%':'50%'"
        :append-to-body="true"
      >
        <Company @selectedCompany="getSelectedCompany"/>
      </el-dialog>
      <Model ref="modelRef" :contractContent="editorContent"/>
    </template>
  </PageWrapper>
</template>
<script>
import { defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import Company from '@/views/createQuotation/quotationCompany.vue'
import PageWrapper from '@/components/PageWrapper/index.vue'
import Model from './model.vue'
import useRootSetting from '@/hooks/useRootSetting'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import { generatePdf } from '@/utils/public-method'

export default defineComponent({
  name: 'CompanyInfo',
  components: { PageWrapper,Model,Company },
  setup() {
    const {getIsMobile} = useRootSetting()
    const offeringFormRef = ref(null)
    const needFormRef = ref(null)
    const needForm = reactive({
      dscompany: '',
      dslxr:'',
      dstel:'',
      dsmax:'',
      dsbank:'',
      dsbanknum:'',
      dsshuihao:''
    })
    const offeringsForm = reactive({
      cname:'',
      rname:'',
      tel:'',
      max:'',
      bank:'',
      banknum:'',
      shuihao:''
    })

    const dialog = ref(false)
    const modelRef = ref(null)
    const editorContent = ref('')
    const parentId = ref(0)
    const companyId = ref(0)
    const handleReset = () => {
      needFormRef.value.resetFields()
      modelRef.value.hs = 0
      modelRef.value.clearTable()
    }

    const modelData = ref([])

    const baseInfo = reactive({
      fplx: '',
      htbh:'',
      uname:'',
      yid: 0
    })
    const handleSubmit = () => {
        request({
          url: 'create_contract.yy',
          method: 'post',
          data: {
            ...{cid: companyId.value},
            ...{content: modelRef.value.editorContent},
            ...baseInfo,
            ...offeringsForm,
            ...needForm,
            ...{kpzt: modelRef.value.hs},
            ...{childdata:modelRef.value.modelList}
          }
        }).then(res => {
          if(res.code == 200) {
            const url =`${res.url}&token=${getToken()}`
            generatePdf(url)
          }
        })
    }

    const getSelectedCompany = (row) => {
      const {company,name,phone,max,cid,kpsbnum,bank,banknum} = row
      needForm.dscompany = company
      needForm.dslxr = name
      needForm.dstel = phone
      needForm.dsmax = max
      needForm.dsbank = bank
      needForm.dsbanknum = banknum
      needForm.dsshuihao = kpsbnum
      companyId.value = cid
      dialog.value = false
    }

    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const getContract = () => {
      request({
        url: 'contract_information.yy',
        method: 'post',
        data: {username: username}
      }).then(res => {
        if(res.code == 200) {
          editorContent.value = res.supplierrow[0].content;
          Object.keys(offeringsForm).forEach(key => {
            if (res.supplierrow[0].hasOwnProperty(key)) {
              offeringsForm[key] = res.supplierrow[0][key];
            }
          });
          Object.keys(baseInfo).forEach(key => {
            if (res.supplierrow[0].hasOwnProperty(key)) {
              baseInfo[key] = res.supplierrow[0][key];
            }
          });
        }
      })
    }

    onMounted(()=>{
      getContract()
    })

    return {
      baseInfo,
      companyId,
      parentId,
      editorContent,
      modelData,
      username,
      getIsMobile,
      dialog,
      offeringFormRef,
      needFormRef,
      needForm,
      offeringsForm,
      modelRef,
      getSelectedCompany,
      handleReset,
      handleSubmit
    }
  }
})
</script>

<style scoped>
.company-info_form {
  padding: 10px 60px 0px 20px
}

.dialog-footer {
  position: absolute;
  right: 20px;
  bottom: 20px;
}

</style>
